(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richdale-bespoke-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var track = root.querySelector('[data-rh-track]');
      var prev = root.querySelector('[data-rh-prev]');
      var next = root.querySelector('[data-rh-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.rh-piece');
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-rh-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-rh-carousel]').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richdale-help"] && !Shopify.designMode) return;
  try {
    
  class RichdaleHelp {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-rh-help-input]');
      this.clear = root.querySelector('[data-rh-help-clear]');
      this.topics = root.querySelector('[data-rh-help-topics]');
      this.groups = Array.from(root.querySelectorAll('[data-rh-help-group]'));
      this.items = Array.from(root.querySelectorAll('[data-rh-help-item]'));
      this.empty = root.querySelector('[data-rh-help-empty]');
      this.status = root.querySelector('[data-rh-help-status]');

      this.items.forEach((item) => {
        item.dataset.rhHelpText = item.textContent.toLowerCase().replace(/\s+/g, ' ');
      });

      if (this.input) {
        this.input.addEventListener('input', () => this.filter());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.reset();
        });
      }

      if (this.clear) {
        this.clear.addEventListener('click', () => this.reset());
      }

      this.root.addEventListener('click', (event) => {
        const link = event.target.closest('.rh-help__topic');
        if (link) this.reset(false);
      });

      this.openFromHash();
      window.addEventListener('hashchange', () => this.openFromHash());
    }

    openFromHash() {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;

      let target = null;
      try {
        target = this.root.querySelector(hash);
      } catch (error) {
        return;
      }
      if (!target) return;

      const item = target.closest('[data-rh-help-item]');
      if (item) item.open = true;
      window.requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    reset(focus = true) {
      if (this.input) this.input.value = '';
      this.filter();
      if (focus && this.input) this.input.focus();
    }

    filter() {
      const query = this.input ? this.input.value.trim().toLowerCase() : '';
      const terms = query.split(/\s+/).filter(Boolean);
      const searching = terms.length > 0;
      let visible = 0;

      this.items.forEach((item) => {
        const haystack = item.dataset.rhHelpText || '';
        const match = !searching || terms.every((term) => haystack.includes(term));
        item.hidden = !match;
        if (match) visible += 1;
        if (searching) {
          item.open = match;
        } else {
          item.open = false;
        }
      });

      this.groups.forEach((group) => {
        const hasVisible = Array.from(group.querySelectorAll('[data-rh-help-item]')).some((item) => !item.hidden);
        group.hidden = !hasVisible;
      });

      if (this.topics) this.topics.hidden = searching;
      if (this.empty) this.empty.hidden = !(searching && visible === 0);
      if (this.clear) this.clear.hidden = !searching;

      if (this.status) {
        this.status.textContent = searching ? `${visible} / ${this.items.length}` : '';
      }
    }
  }

  function initRichdaleHelp() {
    document.querySelectorAll('[data-rh-help]').forEach((root) => {
      if (root.dataset.rhHelpReady === 'true') return;
      root.dataset.rhHelpReady = 'true';
      new RichdaleHelp(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRichdaleHelp);
  } else {
    initRichdaleHelp();
  }

  document.addEventListener('shopify:section:load', initRichdaleHelp);

  } catch(e) { console.error(e); }
})();
})();
